import { SVGProps } from 'react';

export const InvoiceCollection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.4141 0L20 4.58594V16C20 17.103 19.103 18 18 18H8C6.897 18 6 17.103 6 16V2C6 0.898 6.897 0 8 0H15.4141ZM12.25 7.83301C11.0096 7.83301 10.0002 8.95482 10 10.333C10 11.7113 11.0095 12.833 12.25 12.833H13.75C14.164 12.833 14.5 13.207 14.5 13.667C14.4998 14.1268 14.1639 14.5 13.75 14.5H10.75V16.167H12.25V17H13.75V16.167C14.9904 16.167 15.9998 15.0452 16 13.667C16 12.2887 14.9905 11.167 13.75 11.167H12.25C11.836 11.167 11.5 10.793 11.5 10.333C11.5002 9.87316 11.8361 9.5 12.25 9.5H15.25V7.83301H13.75V7H12.25V7.83301ZM14 6H19L14 1V6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3H3V19C3 20.103 3.897 21 5 21H17V19H5V3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6H0V22C0 23.103 0.897 24 2 24H14V22H2V6Z"
      fill="currentColor"
    />
  </svg>
);
